import { render } from "./trustoo.vue?vue&type=template&id=27e16ace"
import script from "./trustoo.vue?vue&type=script&lang=js"
export * from "./trustoo.vue?vue&type=script&lang=js"

import "./trustoo.vue?vue&type=style&index=0&id=27e16ace&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__